import { requestApi } from 'api/Api';

export const getDefaultWizard = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/get_default_wizard',
    method: 'POST',
    params,
    navigate
  });
};

export const createPracticeWizard = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/practice/create',
    method: 'POST',
    params,
    navigate
  });
};

export const createWizardInstance = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/instance/create',
    method: 'POST',
    params,
    navigate
  });
};

export const getWizardInstanceById = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/instance/get',
    method: 'POST',
    params,
    navigate
  });
};

export const getWizardProgressInstanceById = (navigate, params) =>
  requestApi({
    url: '/api/wizard/instance/progress',
    method: 'POST',
    params,
    navigate
  });

export const submitWizardOrchestrator = (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/wizard/orchestrator',
    params
  });
};

export const getWizardOverview = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/instance/overview',
    method: 'POST',
    params,
    navigate
  });
};

export const getWizardInstanceDelegation = (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/wizard/instance/get_delegation',
    params
  });
};

export const delegateTasksForStaff = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/wizard/instance/delegate',
    params
  });

export const updateWizardInstance = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/instance/update',
    method: 'POST',
    params,
    navigate
  });
};

export const principalConfirm = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/wizard/instance/principal_approval',
    params
  });
